import React from "react"
import {
  Container,
  Col,
  Row
} from 'reactstrap';
import Database from "./database/Database"


function HomeScreen(){
    return(
      <div>
        <Container fluid className="pagetitle">
        <Row className="justify-content-center align-items-end">
        <Col xl="12" lg="12" xs="12" className="text-left">
        <h1 className="display-1  text-center">
        COVID-19:  <span className="home-1">Making sense of all the numbers</span>       
        </h1>
        </Col>
        </Row>
        </Container>
        <div className="containhome">
          <Container fluid className="homepage">
            <Row className="justify-content-center align-items-center">
              <Col lg="3" xs="4" className="q1 text-left no-gutters">
              <img src='./jpg/p1.png' className="fluid" alt=""/>
              </Col>
              <Col  lg="3" xs="4" className="q2 text-left no-gutters">
              <img src='./jpg/p2.png' className="fluid" alt=""/>
              </Col>
              <Col  lg="3" xs="4" className="q3 text-left no-gutters">
              <img src='./jpg/p3.png' className="fluid" alt=""/>
              </Col>
              <Col  lg="3" xs="4" className="text-left no-gutters hideit">
              <img src='./jpg/p4.png' className="fluid" alt=""/>
              </Col>
            </Row>
            <Row className="justify-content-center align-items-center">
              <Col  lg="3" xs="4" className="text-left no-gutters hideit">
              <img src='./jpg/p5.png' className="fluid" alt=""/>
              </Col>
              <Col  lg="3" xs="4" className="q4 text-left no-gutters">
              <img src='./jpg/p6.png' className="fluid" alt=""/>
              </Col>
              <Col  lg="3" xs="4" className="q5 text-left no-gutters">
              <img src='./jpg/p7.png' className="fluid" alt=""/>
              </Col>
              <Col  lg="3" xs="4" className="q6 text-left no-gutters">
              <img src='./jpg/p8.png' className="fluid" alt=""/>
              </Col>
            </Row>
            {/* <Row className="justify-content-center align-items-end">
            <Col className='text-center'><a href="#arrow"><img className="arrow" src='./jpg/down.png' width="60px" height="auto" alt=""/></a></Col>
            </Row> */}
          </Container>
          </div>
          

        <Container>
        <Row className="justify-content-center align-items-end">
        <Col lg="10" xs="12">
                <p className="text-center display-4 aliagray givemespace">
                In this five-part graphic series, Al Jazeera helps you filter through the headlines and charts behind the coronavirus.
                </p>
                <br/>
                <p className="text-center aliagray">
                Published: 16 April 2020
                </p>            
              </Col>
        </Row>
        </Container>

          </div>
    )
}
export default HomeScreen

